import { v4 as uuid } from "uuid";

export const CATEGORIES = [
  {
    _id: uuid(),
    img: "https://i.ytimg.com/vi/l98w9OSKVNA/hq720.jpg",
    category: "Lofi",
  },
  {
    _id: uuid(),
    img: "https://i.ytimg.com/vi/T9SkCIK0h2U/hq720.jpg",
    category: "Bollywood",
  },
  {
    _id: uuid(),
    img: "https://i.ytimg.com/vi/woAHwpOLmyY/hq720.jpg",
    category: "Anime",
  },
  {
    _id: uuid(),
    img: "https://i.ytimg.com/vi/kJQP7kiw5Fk/hq720.jpg",
    category: "Hollywood",
  },
];